import { httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';
import type { CheckoutType } from '@/lib/constants';

export interface SubscriptionPayRequestBody {
  title: string;
  payment_type: CheckoutType.Subscription;
  amount: number;
  description: string;
  subscription_id: string;
  plan_id: string;
  method_id: string;
  method_type: string;
  return_url?: string;
}

export interface ReimbursementPayRequestBody {
  title: string;
  payment_type: CheckoutType.Reimbursement;
  payment_provider: string;
  amount: number;
  order_id: string;
  description: string;
  return_url?: string;
}

export interface TipPayRequestBody {
  title: string;
  payment_type: CheckoutType.Tip;
  payment_provider: string;
  amount: number;
  order_id: string;
  description: string;
  return_url?: string;
}

export type PayRequestBody =
  | SubscriptionPayRequestBody
  | ReimbursementPayRequestBody
  | TipPayRequestBody
  | null;

export interface PaymentResponse {
  redirect_url: string;
}

export const payFn = async (
  body: PayRequestBody,
  checkoutType: string,
  isAutoDebit = false
) => {
  const headers: Record<string, any> = {
    'Content-Type': 'application/json',
    'Is-Auto-Debit': isAutoDebit,
  };

  const response = await httpClient.post<PaymentResponse>(
    apiRoutes.payment.pay(checkoutType),
    body,
    {
      headers,
    }
  );
  return response.data;
};
